import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_BROADCAST_NOTIFICATION } from "../../../config/api";

export const broadcastNotification = createAsyncThunk(
  "notification/broadcast",
  async ({ data, fail, callback }, { dispatch, rejectWithValue }) => {
    try {
      const response = await Client({
        method: "POST",
        path: API_BROADCAST_NOTIFICATION,
        data: data,
      });

      toast.success(response?.data?.message);
      callback();
      return response?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      fail();
      toast.error(msg);
      return rejectWithValue(error.message);
    }
  },
);
